import axios from 'axios';
import { API_BASE_URL, endpoints } from './config';

const apiClient = axios.create({
    baseURL: `${API_BASE_URL}/api`,
    params: { lang: 'en' },
});

export const fetchCops = async ({  lang }) => {
    try {
        const response = await apiClient.get(endpoints.cop.list, {
                    params: {
                        lang, 
                    },
                });
        
        return response.data;
    } catch (error) {
        console.error('Error fetching COPs:', error);
        throw new Error(error.response?.data?.detail || 'Failed to fetch COPs');
    }
};